const SHOWN_STORAGE_KEY_PREFIX = 'storage-upsell-reminder-shown-';

function getTodayStorageValue() {
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');

  return `${now.getFullYear()}-${month}-${day}`;
}

export function useStorageUpsellReminder() {
  const sessionStore = useSessionStore();
  const {areModalsOpen} = useFModals();
  const {openStorageUpsellModal} = useCommonModals();

  function showStorageUpsellReminder() {
    if (!process.client || !sessionStore.currentUser?.isStorageFull) {
      return;
    }

    const storageKey = `${SHOWN_STORAGE_KEY_PREFIX}${sessionStore.currentUser.id}`;
    const today = getTodayStorageValue();

    if (localStorage.getItem(storageKey) === today) {
      return;
    }

    localStorage.setItem(storageKey, today);

    const openReminder = () => openStorageUpsellModal({
      context: STORAGE_UPSELL_CONTEXTS.sessionStorageFullReminder
    });

    if (!areModalsOpen.value) {
      openReminder();
      return;
    }

    const stop = watch(areModalsOpen, isOpen => {
      if (!isOpen) {
        stop();
        openReminder();
      }
    });
  }

  return {
    showStorageUpsellReminder
  };
}
